import * as React from 'react';
import { Row, Col } from 'react-bootstrap';

import { Button } from '@acceligentllc/storybook';

interface OwnProps {
	isVisible: boolean;
	toggle: () => void;
	renderContent: () => Nullable<React.JSX.Element>;
	isExpanded: boolean;
	label: string;
}

type Props = OwnProps;

const AccountEditSegment: React.FC<Props> = (props) => {
	const { isVisible, renderContent, toggle, isExpanded, label } = props;

	if (!isVisible) {
		return null;
	}

	const iconName = isExpanded ? 'ActionCollapsedOutline' : 'ActionExpandedOutline';

	return (
		<>
			<Row>
				<Col className="m-b-s m-t-s" sm={24}>
					<Button
						icon={iconName}
						label={label}
						onClick={toggle}
						style="link"
					/>
				</Col>
			</Row>
			{isExpanded && renderContent()}
		</>
	);

};

export default React.memo(AccountEditSegment);
